<template>
  <div>
    <d-select
      :items="usersForList"
      :itemsSelected="selectedUsers"
      :eventId="eventId"
      :allDataLoaded="allDataLoaded"
      :show="show"
      :addClass="addClass"
      @remove="removeUser"
      @add="addUser"
      @addIsOnLesson="addedIsOnLesson"
      @update="setSelectedUsers"
      @show="getUsers">
    </d-select>
    <transition name="fadeIn">
      <div class="subModal__bg" v-if="subFromIsOnLesson !== null">
        <div class="subModal">
          <h2>{{ i18n['would_you_like_to_set'] }} {{ subFromIsOnLesson.name }} {{ i18n['as_a_substitute_instead_of_teacher'] }}?</h2>
          <div class="subModal__buttons">
            <button @click="setSubFromIsOnLesson">{{ i18n['yes'] }}</button>
            <button class="bttn-simple bttn" @click="subFromIsOnLesson = null">{{ i18n['no'] }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import dSelect from './DSelect'
import docendo from '../../docendo'
import {maskHiddenAbsenceTitlesInAvailability} from '../../utils/hiddenAbsenceTitle'
import {mapGetters} from 'vuex'

const I18N = {
  da: {
    user_not_found: 'Brugeren er fjernet fra skolen',
    would_you_like_to_set: 'Vil du sætte',
    as_a_substitute_instead_of_teacher: 'på som vikar i stedet for underviser',
    yes: 'Ja',
    no: 'Nej'
  },
  nb: {
    user_not_found: 'Brukeren er fjernet fra skolen',
    would_you_like_to_set: 'Vil du sette',
    as_a_substitute_instead_of_teacher: 'som vikar istedenfor lærer',
    yes: 'Ja',
    no: 'Nej'
  },
  en: {
    user_not_found: 'User is removed from school',
    would_you_like_to_set: 'Would you like to set',
    as_a_substitute_instead_of_teacher: 'as a substitute instead of a teacher',
    yes: 'Yes',
    no: 'No'
  }
}

export default {
  components: {dSelect},
  props: {
    eventId: {
      type: Number
    },
    startTime: {
      type: String,
      default: '2018-06-19 07:00'
    },
    endTime: {
      type: String,
      default: '2018-06-19 14:00'
    },
    subs: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: () => {
      }
    },
    othersOnLesson: {
      type: Array,
      default: () => []
    },
    show: {
      default: false,
      type: Boolean
    },
    addClass: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    eventId () {
      this.selectedForehand = this.subs
      this.getUsersSelectedForehand()
      this.getOccupiedUsers()
    },
    user () {
      this.selectedForehand = this.subs
      this.getUsersSelectedForehand()
      this.getOccupiedUsers()
    }
  },
  computed: {
    ...mapGetters([
      'allUsersSortedOnName',
      'locale'
    ]),
    i18n () {
      return I18N[this.locale]
    },
    userNotFoundPlaceholder () {
      return {
        id: 0,
        name: this.i18n['user_not_found'],
        type: 'user',
        url: '/calendar',
        calendar_id: 0,
        dayAbsence: [],
        dayEvents: [],
        dayAllEvents: [],
        default_thumb_url: '',
        user_tags: [],
        occupied: false,
        isOnLesson: false,
        currentEventId: 0,
        user_calendar_id: 0,
        isErrorUser: true
      }
    },
    filterAbsentUser () {
      let filterUserIds = [this.user.id]
      return this.allUsersSortedOnName.filter(user => filterUserIds.indexOf(user.id) === -1)
    },
    usersForList () {
      let users = this.filterAbsentUser.map(obj => {
        let occ = false
        let isOnLesson = false
        let isWithAvailability = false
        if (this.occupiedUsers[obj.user_calendar_id]) {
          occ = this.occupiedUsers[obj.user_calendar_id]
          isOnLesson = this.othersOnLesson.filter(user => user.user_calendar_id === obj.user_calendar_id).length > 0
          isWithAvailability = occ.events.filter(event => event.event_type === 'available').length > 0
        }
        let user = {
          id: obj.id,
          default_thumb_url: obj.default_thumb_url,
          name: obj.name,
          user_tags: obj.user_tags,
          occupied: occ,
          currentEventId: this.eventId,
          isOnLesson: isOnLesson,
          isWithAvailability: isWithAvailability,
          user_calendar_id: obj.user_calendar_id
        }
        return user
      })
      users.push(this.userNotFoundPlaceholder)
      return users
    }
  },
  data () {
    return {
      selectedUsers: [],
      occupiedUsers: [],
      allDataLoaded: false,
      selfIsLoading: false,
      subFromIsOnLesson: null
    }
  },
  methods: {
    getUsers (val) {
      if (val) {
        this.getOccupiedUsers()
      }
    },
    addUser (user) {
      this.$emit('add', user)
    },
    removeUser (user) {
      this.$emit('remove', user)
    },
    setSelectedUsers (val) {
      this.selectedUsers = val
      this.$emit('updated', this.selectedUsers)
    },
    getUsersSelectedForehand () {
      this.selectedUsers.splice(0, this.selectedUsers.length)
      for (let i = 0; i < this.selectedForehand.length; i++) {
        for (let j = 0; j < this.usersForList.length; j++) {
          if (this.usersForList[j].id === this.selectedForehand[i].id) {
            if (this.selectedUsers.filter(obj => obj.id === this.selectedForehand[i].id).length === 0) {
              this.selectedUsers.push(this.usersForList[j])
            }
          }
        }
      }
    },
    getOccupiedUsers () {
      docendo.schoolAvailabilities(window.SCHOOL.id, 'user', this.startTime, this.endTime, data => {
        let toArr = maskHiddenAbsenceTitlesInAvailability(JSON.parse(data), this.$store, window.SCHOOL.id)
        let newUsers = {}
        for (let i = 0; i < toArr.length; i++) {
          newUsers[toArr[i].calendar_id] = toArr[i]
        }
        this.occupiedUsers = newUsers
        if (!this.allDataLoaded) {
          this.getUsersSelectedForehand()
        }
        this.allDataLoaded = true
        this.selfIsLoading = false
      })
    },
    addedIsOnLesson (sub) {
      this.subFromIsOnLesson = sub
    },
    setSubFromIsOnLesson () {
      // this.addUser(this.subFromIsOnLesson)
      for (let j = 0; j < this.usersForList.length; j++) {
        if (this.usersForList[j].id === this.subFromIsOnLesson.id) {
          this.selectedUsers.push(this.usersForList[j])
        }
      }
      docendo.eventAddSubstitute(this.eventId, this.subFromIsOnLesson.id, this.user.id, data => {
        this.subFromIsOnLesson = null
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$emit('addedSubFromTeachers')
      })
    }
  },
  beforeMount () {
    this.selectedForehand = this.subs
    if (this.selectedForehand.length > 0) {
      this.getOccupiedUsers()
    }
  }
}
</script>

<style scoped>

.subModal__bg {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.51);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

.subModal {
  z-index: 10001;
  width: 500px;
  height: 200px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  box-shadow: 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12), 0 11px 15px -7px rgba(0, 0, 0, .2);
  border-radius: 4px;
  border: 1px solid #ccc;
}

.subModal h2 {
  background: #f6f7f8;
  text-align: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d8d8d8;
}

.subModal__buttons {
  display: flex;
  padding-top: 40px;
  margin: 0 auto;
  justify-content: center;
}

.subModal__buttons > button {
  width: 100px;
}

.subModal__buttons > button:first-child {
  margin-right: 10px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.fadeIn-enter-active {
  transition: all .3s ease;
}

.fadeIn-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.fadeIn-enter, .fadeIn-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// DSelectSubs.vue?48d0fff0